import { useSpring, animated } from 'react-spring'
import styled from 'styled-components'
import React, { useState, useCallback } from 'react'
import theme from 'live/services/theme'
import i18n from 'live/services/i18n'

export default function WbsOverlay(props: { theme: string; height: number; show: boolean }) {
    if (props.show == false) {
        return null
    }

    const [collapsed, setCollapsed] = useState(false)
    const onClick = useCallback(() => setCollapsed(c => !c), [])

    const heightSpring = useSpring({ height: collapsed ? '40px' : `${props.height}px` })

    const fadeTextOpen = useSpring({ opacity: collapsed ? 0 : 1, display: collapsed ? 'none' : 'block' })
    const fadeTextCollapsed = useSpring({ opacity: collapsed ? 1 : 0, display: collapsed ? 'block' : 'none' })

    return (
        <Container currentTheme={props.theme} style={{ ...heightSpring }}>
            <animated.div className="textOpen" style={fadeTextOpen}>
                <div style={{ overflow: 'auto', maxHeight: `${props.height}px` }}>
                    <i className="far fa-exclamation-circle"></i>
                    <span>
                        {i18n('Errors were found in the trajectory data, which can impact the rendering of the graph.')}
                    </span>
                    <a onClick={onClick}>{i18n('View the chart anyway')}</a>
                </div>
            </animated.div>
            <animated.div className="textCollapsed" style={fadeTextCollapsed}>
                <div>
                    <i className="far fa-exclamation-circle"></i>
                    <span title={i18n('Errors were found that can affect the rendering of the chart')}>
                        {i18n('Errors were found that can affect the rendering of the chart')}
                    </span>
                    <i className="far fa-chevron-up hasOnClick" onClick={onClick}></i>
                </div>
            </animated.div>
        </Container>
    )
}

const Container = styled(animated.div)`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background: ${({ currentTheme }) => (currentTheme !== 'dark' ? 'white' : theme['dark-bg'])};
    opacity: 0.9;
    z-index: 11;

    .textOpen {
        > div {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;

            > * {
                text-align: center;
            }

            > span {
                display: block;
                padding-bottom: 20px;
                color: ${({ currentTheme }) => (currentTheme !== 'dark' ? theme['text-color'] : 'white')};
            }

            > i {
                font-size: 64px;
                padding-bottom: 20px;
            }
        }
    }

    .textCollapsed {
        height: 100%;
        background-color: #ffbbb9;

        > div {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;

            > span {
                white-space: pre;
                text-overflow: ellipsis;
                overflow: hidden;
                flex: 1;
                text-align: center;
                color: ${theme['text-color']};
            }

            > i {
                font-size: 18px;
                padding-left: 14px;
                padding-right: 14px;
            }
        }
    }

    i {
        color: #d9534f;
    }

    .hasOnClick {
        cursor: pointer;
    }
`
